module.exports = __webpack_public_path__ + "img/relvado_pt.e6ea3f8f.jpg";